<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="TPO: IMP Links and Downloads"
                   :links="[{title:'Home', url:'/'},{title:'TPO', url: ''}, {title: 'IMP Links and Downloads'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="11"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">IMP Links and Downloads</div>
          <tab-view>
            <tab-panel header="Links">
              <div class="rounded-lg shadow-md">
                <table class="w-full">
                  <tbody>
                  <tr class="bg-white border-b hover:bg-gray-100">
                    <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Link1</td>
                    <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700 text-center hover:text-pink-600"><a href=""><i class="pi pi-link"></i></a> </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-panel>
            <tab-panel header="Downloads">
              <div class="rounded-lg shadow-md">
                <table class="w-full">
                  <tbody>
                  <tr class="bg-white border-b hover:bg-gray-100">
                    <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700">Form1</td>
                    <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-700 text-center hover:text-pink-600"><a href=""><i class="pi pi-download"></i></a> </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-panel>
          </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/tpo/Sidebar";
import KeyRecruiters from "@/components/KeyRecruiters";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
export default {
  name: "PlacementRecord",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    TabView,
    TabPanel
  },
}
</script>
<style lang="scss" scoped/>
